import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import Heading from '../../Components/Heading/heading.tsx';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (selectedAction: string) => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm,
}) => {
  const [selectedAction, setSelectedAction] = useState<string>('');
  const [showReconfirm, setShowReconfirm] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setSelectedAction('');
      setShowReconfirm(false);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (selectedAction === "1") { 
      setShowReconfirm(true);
    } else {
      onConfirm(selectedAction);
      onClose();
    }
  };

  const handleFinalConfirm = () => {
    onConfirm(selectedAction);
    onClose();
  };



  return (
    <>
    
      <Dialog open={isOpen && !showReconfirm} onClose={onClose} maxWidth='xs' fullWidth={true}>
            <Box
                   sx={{
                     marginLeft: {
                       xs: '0px',
                       sm: '-180px',
                     },
                   }}
                 >  
          <Heading 
            title="Choose an action"
            closeIcon="true" 
            onClose={onClose} 
          />
        </Box>
        <DialogContent>
          <Box sx={{ mt: 2, ml: 2, mr: 2 , display:'flex', justifyContent:'center'}}>
            <Dropdown
              options={[
                { id: '1', label: 'Switch driver to this vehicle' },
                { id: '2', label: 'Add driver to this vehicle also' },
                { id: '3', label: 'Cancel' }
              ]}
              selectedValue={selectedAction}
              handleChange={(e) => setSelectedAction(e.target.value)}
              placeholder="Select action"
              width="300px"
              displayEmpty={true}
            />
          </Box>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          <Button 
            className="custom-button" 
            onClick={handleConfirm}
            disabled={!selectedAction}
          >
            Confirm
          </Button>
          <Button 
            className="custom-cancel-button" 
            onClick={onClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {selectedAction === "1" && (
        <Dialog open={showReconfirm} onClose={() => setShowReconfirm(false)}>
        <Box
                   sx={{
                     marginLeft: {
                       xs: '0px',
                       sm: '-180px',
                     },
                   }}
                 >
            <Heading 
              title="Re-confirm Action" 
              closeIcon="true" 
              onClose={() => setShowReconfirm(false)} 
            />
          </Box>
          <DialogContent>
            <Box sx={{ mt: 2, p: 2 }}>
              <Typography variant="body1">
                Are you sure you want to switch the driver to this new vehicle?
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
            <Button 
              className="custom-button" 
              onClick={handleFinalConfirm}
            >
              Yes, Proceed
            </Button>
            <Button 
              className="custom-cancel-button" 
              onClick={() => setShowReconfirm(false)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default ConfirmationModal;